import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderProductChecklistChecked(props: TypicalMessageProps<'order-product.checklist-marked-as-checked'>) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            optionsKey={props.optionsKey}
            replace={{
                order_id: props.model.message_details.order_id,
                product_id: props.model.message_details.product_id,
                checklist_title: <span className="p-1">{props.model.message_details.checklist_title}</span>,
            }}
    />;
}
